
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { actions } from '@/store/types';
import { ResetPasswordActionType } from '@/types/store/actions';
import { contactUsURL, privacyPolicyURL, termsAndConditionsURL } from '@/constants/constants';
import { reCAPTCHASiteKey } from '@/config';
import VueRecaptcha from 'vue-recaptcha';

@Component({
    components: {
        'vue-recaptcha': VueRecaptcha,
    },
})
export default class ResetPassword extends Vue {
    @Action(actions.RESET_PASSWORD)
    ResetPassword!: ResetPasswordActionType;
    protected captchaVerified = false;
    reCAPTCHASiteKey = reCAPTCHASiteKey;

    email = '';
    contactUsURL = contactUsURL;
    privacyPolicyURL = privacyPolicyURL;
    termsAndConditionsURL = termsAndConditionsURL;

    handleResetPassword(e: Event) {
        e.preventDefault();
        if (!this.captchaVerified) {
            return Vue.toasted.error(`reCAPTCHA required`);
        }
        this.ResetPassword({ email: this.email });
    }
    onCaptchaVerified(response: any) {
        if (response) this.captchaVerified = true;
    }

    onCaptchaExpired() {
        this.captchaVerified = false;
    }
}
